import { useState, useEffect, useCallback } from "react";
import { api } from "../api";
import KPICards from "../components/KPICards";
import RevenueChart from "../components/RevenueChart";
import TopProductsChart from "../components/TopProductsChart";
import { PaymodeChart, PartyTypeChart } from "../components/PaymodeCharts";
import DateBar, { today, daysAgo } from "../components/DateBar";

export default function Dashboard({ showToast }) {
  const [preset, setPreset] = useState(1);
  const [start, setStart] = useState(daysAgo(6));
  const [end, setEnd] = useState(today);
  const [loading, setLoading] = useState(false);
  const [kpi, setKpi] = useState(null);
  const [daily, setDaily] = useState([]);
  const [products, setProducts] = useState([]);
  const [paymode, setPaymode] = useState([]);
  const [partytype, setPartytype] = useState([]);
  const [states, setStates] = useState([]); // ✅ add this

  const fetchAll = useCallback(
    async (s, e) => {
      setLoading(true);
      try {
        const [k, d, p, pm, pt, st] = await Promise.all([
          api.kpi(s, e),
          api.daily(s, e),
          api.products(s, e),
          api.paymode(s, e),
          api.partytype(s, e),
          api.states(s, e), // ✅ add this
        ]);
        setKpi(k);
        setDaily(d);
        setProducts(p);
        setPaymode(pm);
        setPartytype(pt);
        setStates(st); // ✅ add this
      } catch {
        showToast("Failed to fetch data", "error");
      } finally {
        setLoading(false);
      }
    },
    [showToast],
  );

  useEffect(() => {
    fetchAll(start, end);
  }, [start, end, fetchAll]);

  // ✅ Top state is first item (already sorted by revenue)
  const topState = states.length > 0 ? states[0] : null;
  const bottomState = states.length > 0 ? states[states.length - 1] : null;

  return (
    <div className="page-body">
      <div className="page-title">Dashboard</div>
      <div className="page-subtitle">Overview of all sales activity</div>

      <DateBar
        start={start}
        end={end}
        preset={preset}
        setStart={setStart}
        setEnd={setEnd}
        setPreset={setPreset}
        loading={loading}
      />

      {/* ✅ Pass topState to KPICards */}
      <KPICards kpi={kpi} topState={topState} bottomState={bottomState} />

      <RevenueChart data={daily} />

      <div className="grid-2">
        <PaymodeChart data={paymode} />
        <PartyTypeChart data={partytype} />
      </div>

      <TopProductsChart data={products} start={start} end={end} />
    </div>
  );
}
